module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/store_images/1_3919f855979f9c54fb36846ccb29a09c.png";